__turbopack_context__.v({
  "disabled": "BuildInput-module-sass-module__ZgsfoG__disabled",
  "disabled__value": "BuildInput-module-sass-module__ZgsfoG__disabled__value",
  "form-hint": "BuildInput-module-sass-module__ZgsfoG__form-hint",
  "form-hint--dense": "BuildInput-module-sass-module__ZgsfoG__form-hint--dense",
  "input-group": "BuildInput-module-sass-module__ZgsfoG__input-group",
});
